class PdpTabs extends HTMLElement {
  constructor() {
    super();

    this.addEventListener("click", (e) => {
      const button = e.target.closest("button");
      if (button) {
        button.scrollIntoView({
          behaviour: "smooth",
          block: "nearest",
          inline: "nearest",
        });
      }
    });
  }
}

if (!customElements.get("pdp-tabs")) {
  customElements.define("pdp-tabs", PdpTabs);
}
